module.exports = __webpack_public_path__ + "images/ico-video.svg?a9f1168b4a406076ea83b6e6fbb20704";